/// <amd-module name="Artifacts/FeedSettings/types/IUpstreamSource" />
import {
  UpstreamSourceType,
  UpstreamStatus,
  UpstreamStatusDetail,
} from "Artifacts/Root/web-apis/contracts/Feed";

export interface IUpstreamSource {
  /**
   * UTC date that this upstream was deleted.
   */
  deletedDate?: Date | null;
  /**
   * Locator for connecting to the upstream source in a user friendly format, that may potentially change over time
   */
  displayLocation: string | null;
  /**
   * Identity of the upstream source.
   */
  id: string | null;
  /**
   * For an internal upstream type, track the Azure DevOps organization that contains it.
   */
  internalUpstreamCollectionId: string | null;
  /**
   * For an internal upstream type, track the feed id being referenced.
   */
  internalUpstreamFeedId: string | null;
  /**
   * For an internal upstream type, track the project of the feed being referenced.
   */
  internalUpstreamProjectId: string | null;
  /**
   * For an internal upstream type, track the view of the feed being referenced.
   */
  internalUpstreamViewId: string | null;
  /**
   * Consistent locator for connecting to the upstream source.
   */
  location: string | null;
  /**
   * Display name.
   */
  name: string;
  /**
   * Package type associated with the upstream source.
   */
  protocol: string;
  /**
   * The identity of the service endpoint that holds credentials to use when accessing the upstream.
   */
  serviceEndpointId?: string | null;
  /**
   * Specifies the projectId of the Service Endpoint.
   */
  serviceEndpointProjectId?: string | null;
  /**
   * Specifies the status of the upstream.
   */
  status?: UpstreamStatus;
  /**
   * Provides a human-readable reason for the status of the upstream.
   */
  statusDetails?: UpstreamStatusDetail[];
  /**
   * Source type, such as Public or Internal.
   */
  upstreamSourceType: UpstreamSourceType;
}
